import React, { useState, useEffect } from 'react';
import { Modal, Collapse, Input, Spin } from 'antd';
import { getFaqs } from "../../../API/faqs";
import './FAQModal.css';

const { Panel } = Collapse;
const { Search } = Input;

const FAQModal = ({ visible, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setLoading(true);
      getFaqs()
        .then((res) => {
          setFaqData(res || []);
        })
        .catch((err) => {
          console.error("Error al obtener FAQs:", err);
        })
        .finally(() => setLoading(false));
    }
  }, [visible]);

  const filteredData = faqData.filter(
    item =>
      item.question?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.answer?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Modal
      className="dependency-modal"
      title="Preguntas Frecuentes"
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <Search
        className="faq-search"
        placeholder="Buscar Pregunta..."
        onChange={e => setSearchTerm(e.target.value)}
        value={searchTerm}
        style={{ marginBottom: 20 }}
      />

      {loading ? (
        <Spin className="custom-spin" />
      ) : (
        <Collapse
          className="faq-collapse scrollable-faq"
          defaultActiveKey={['0']}
        >
          {filteredData.length > 0 ? (
            filteredData.map(item => (
              <Panel header={item.question} key={item.key || item.id} className="faq-panel">
                {item.answer}
              </Panel>
            ))
          ) : (
            <p>No se encontraron resultados</p>
          )}
        </Collapse>
      )}
    </Modal>
  );
};

export default FAQModal;